import React from 'react'

import { GiHamburgerMenu } from "react-icons/gi";
import { useDispatch } from 'react-redux';
import {handleLogOut} from '../service/loginServices'
import styles from "./TopNav.module.scss";
function TopNav(props) {
  const dispatch = useDispatch();
  const userLogOut = () =>{
    dispatch(handleLogOut());
  }
  return (
    <div className={styles.TopNav_container}>
      <button
        onClick={() => {
          props.setnav(!props.nav);
        }}
        className={styles.nav_toggle}
      >
        <GiHamburgerMenu />
      </button>

      <button onClick={userLogOut} className={styles.logoutBtn}>Logout</button>
    </div>
  );
}

export default TopNav